import React, {Component} from 'react';

import TopNav from '../TopNav/TopNav';

class MainLayout extends Component {
	render() {
		return (
			<div>
				<TopNav {...this.props.TopNav} />
				{this.props.children}
			</div>
		);
	}
}

export default MainLayout;
